import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: 'website' | 'article';
  publishedTime?: string;
  author?: string;
  keywords?: string;
  /** Schema.org JSON-LD object(s) for this page. Must describe visible content only. */
  jsonLd?: object | object[];
}

// Defaults match the static tags in index.html so the homepage title does not
// change when React hydrates and Helmet takes over the document head.
export const SEO: React.FC<SEOProps> = ({
  title = 'Rongeka Africa | School Management System for Zimbabwean Schools',
  description = 'School management system for Zimbabwean schools. Attendance, fees, and results via WhatsApp. Free for one full term, then $0.50 per student per month. No setup fees.',
  image = 'https://rongeka.africa/rongeka_logo.png',
  url = 'https://rongeka.africa/',
  type = 'website',
  publishedTime,
  author = 'Rongeka Africa',
  keywords = 'school management System, school management software Africa, student management system, attendance tracking, school fees payment system, WhatsApp school communication, ZIMSEC report cards',
  jsonLd,
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Rongeka Africa" />
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {author && type === 'article' && <meta property="article:author" content={author} />}
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};
